import { createAction, props } from '@ngrx/store';

import { DocumentDetailTab } from '@main/utils';

export const saveSummaryPanelData = createAction(
    '[Document] Save Summary Panel Data',
    props<{
        selectedDocument?: number | null;
        selectedDiscrepancy: number | null;
        selectedTab?: DocumentDetailTab | null;
    }>(),
);

export const saveSelectedDiscrepancy = createAction(
    '[Document] Save Selected Discrepancy',
    props<{
        selectedDiscrepancy: number | null;
    }>(),
);
